import bookReducer from "./book/reducer";
import {combineReducers} from "redux";
import editReducer from "./edit/reducer";

const rootReducer = combineReducers({
    books: bookReducer,
    edit: editReducer
});

export default rootReducer;